import { createI18n } from "vue-i18n";
import en from "./en-US.js";

export const LOCALE_STORAGE_KEY = "allfo-user.locale";
export const supportedLocales = ["zh-CN", "en-US"];

function initialLocale() {
  try {
    const saved = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (supportedLocales.includes(saved)) return saved;
  } catch { /* Storage may be unavailable. */ }
  return "zh-CN";
}

const sourceKeys = Object.keys(en);
const messageKeys = new Map(sourceKeys.map((source, index) => [source, `message${index}`]));
const messages = {
  "zh-CN": Object.fromEntries(sourceKeys.map((source, index) => [`message${index}`, source])),
  "en-US": Object.fromEntries(sourceKeys.map((source, index) => [`message${index}`, en[source]])),
};

export const i18n = createI18n({
  legacy: false,
  locale: initialLocale(),
  fallbackLocale: "zh-CN",
  messages,
  missingWarn: false,
  fallbackWarn: false,
});
export const locale = i18n.global.locale;

export function setLocale(value) {
  if (!supportedLocales.includes(value)) return;
  locale.value = value;
  try { localStorage.setItem(LOCALE_STORAGE_KEY, value); } catch { /* Storage may be unavailable. */ }
}

// Chinese source text is the key, so the existing copy stays the source of truth.
export function t(source) {
  const key = messageKeys.get(source);
  return key ? i18n.global.t(key) : source;
}
